import React, { Component } from 'react';
import local from '../../global/js/locale';
import Select from 'react-select'
import { CgSearch } from 'react-icons/cg';
import './Payment.scss'
import store from './../../Store/Store'
import moment from 'moment';
class Filter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Record: '',
            orderdata: props.OrderData,
            Status: props.Status,
            SyncNetsuite: props.Sync,
            States: 0,
            applayfilter: [],
            PaymentNo: '',
            OrderNo: '',
            Fromdate: '',
            Todate: '',
            Name: '',
            Email: '',
            filter: false,
            selectedOption: { value: "", label: 'Any', id: 1 },
            paymentOption: { value: "Any", label: 'Any', id: 1 },
            syncnetsute: { value: "Any", label: 'Any', id: 1 },
            paymentmethod: props.PaymentMethod,
            varchar: local.VARCHAR,
            Int: local.INT,
            update: store.getState().urlappend,
            fromactive: 'active',
            toactive: "active",
            FORMAT: local.locale.DATE.FORMAT,
            fromopacity: '',
            toopactity: '',
            currenDate: new Date().toJSON().slice(0, 10)
        }
        this.handleForm = this.handleForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handlePayment = this.handlePayment.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.HandleLoad = this.HandleLoad.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.Filter !== this.state.Filtervalue) {
            console.log('filter', nextProps.Filter)
            if (nextProps.Filter == true) {
                this._isMounted && this.handleCheck();
                this._isMounted && this.HandleLoad();
            }
        }

    }
    /**
* @description The function executed the component exists
*/
    componentWillUnmount() {
        this._isMounted = false;


    }
    /**
* @description The function executed for before the component call
*/
    HandleLoad() {
        var update = this.state.update;
        let params = new URLSearchParams(document.location.search)
        //The search param not empty convert the serach parammeter to object
        console.log(update)
        if (window.location.search != null && window.location.search != '') {
            var search = window.location.search.substring(1);
            update = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) })
            if (update.status != '' && update.status != null) {
                var obj = this.state.Status.find(item => item.value === update.status.toUpperCase())
                this.setState({ selectedOption: obj });
            }
            if (update.paymentmethod != '' && update.paymentmethod != null) {
                var obj = this.state.paymentmethod.find(item => item.value === update.paymentmethod)
                console.log(obj)
                this.setState({ paymentOption: obj });
            }
            if (update.fromdate != '' && update.fromdate != null) {
                let target = document.getElementsByName("fromdate")[0];
                let targets = document.getElementsByName("fromdate")[1];
                this.setState({ fromactive: 'active' });
                this.setState({ fromopacity: 'active' });
                target.setAttribute(
                    "data-date",
                    moment(update.fromdate, "YYYY-MM-DD")
                        .format(target.getAttribute("data-date-format"))
                );
                targets.setAttribute(
                    "data-date",
                    moment(update.fromdate, "YYYY-MM-DD")
                        .format(targets.getAttribute("data-date-format"))
                );
            }
            if (update.todate != '' && update.todate != null) {
                let target = document.getElementsByName("todate")[0];
                let targets = document.getElementsByName("todate")[1];
                this.setState({ toactive: 'active' });
                this.setState({ toopactity: 'active' });
                let enddate = moment(update.todate, "YYYY-MM-DD").add(-1, 'days').format('YYYY-MM-DD');
                target.setAttribute(
                    "data-date",
                    moment(enddate, "YYYY-MM-DD")
                        .format(target.getAttribute("data-date-format"))
                );
                targets.setAttribute(
                    "data-date",
                    moment(enddate, "YYYY-MM-DD")
                        .format(targets.getAttribute("data-date-format"))
                );

            }
        }
    }
    /**
* @description The function executed for before the component call
*/
    componentDidMount() {
        this._isMounted = true;
        this._isMounted && this.handleCheck();
        this._isMounted && this.HandleLoad();


    }

    /**
* @description The function executed for set the the updated value of the filters
*/
    async handleCheck() {
        setTimeout(
            function () {
                document.getElementById("fromdate").classList.add("active");

                document.getElementById("todate").classList.add("active");
            }
                .bind(this),
            1000
        );
        // store.dispatch({ type: 'urlappend', Urlappend: this.state.update })
        store.subscribe(() => {
            this._isMounted && this.setState({ update: store.getState().urlappend })
            if (store.getState().urlappend) {
                //the sync with netsute is not empty set the select box value
                if (store.getState().urlappend.paymentmethod == '' || store.getState().urlappend.paymentmethod == undefined) {
                    var paymentOption = { value: "", label: 'Any', id: 1 }
                    this._isMounted && this.setState({ paymentOption: paymentOption });
                }
            }
            // set the value of the status from the store
            if (store.getState().urlappend) {
                if (store.getState().urlappend.status == '' || store.getState().urlappend.status == undefined) {
                    var selectedOption = { value: "", label: 'Any', id: 1 }
                    this._isMounted && this.setState({ selectedOption: selectedOption });
                }
            }
        })


    }
    /**
* @description The function executed for change status
*/
    handleChange = selectedOption => {
        this.setState({ selectedOption });
        console.log(`Option selected:`, selectedOption);
        var update = this.state.update
        update['status'] = selectedOption.value.toLowerCase()
        this.setState({ update: update });
        store.dispatch({ type: 'urlappend', Urlappend: update })
    };

    /**
* @description The function executed for changes in the input box stores object
*/
    handleForm(e) {
        var update = store.getState().urlappend;
        var key = e.target.id;
        var value = e.target.value;
        update[key] = value
        this.setState({ update: update });
        store.dispatch({ type: 'urlappend', Urlappend: update })
        console.log(update)
    }
    /**
* @description The function executed for submit the form
*/
    handleSubmit() {
        var update = store.getState().urlappend;
        update['page'] = 1;
        update = Object.keys(update)
            .filter((k) => update[k] != '')
            .reduce((a, k) => ({ ...a, [k]: update[k] }), {});
        var str = "";
        for (var key in update) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(update[key]);
        }
        store.dispatch({ type: 'urlappend', Urlappend: update })
        this.props.history.push({
            pathname: '/payment',
            search: "?" + str.toString()
        })
        this.props.passToParent(true)
        setTimeout(
            function () {
                this.props.passToParent(false)
            }
                .bind(this),
            3000
        );
    }
    /**
   * @description The function executed for changes in the date
   */
    handleDate(e, index) {
        var update = this.state.update
        var key = e.target.id;
        var startdate = e.target.parentNode.parentNode.parentElement.querySelector(
            "#fromdate"
        ).value;
        var enddate = e.target.parentNode.parentNode.parentElement.querySelector(
            "#todate"
        ).value;
        let target = document.getElementsByName(key)[0];
        let targets = document.getElementsByName(key)[1];
        target.setAttribute(
            "data-date",
            moment(e.target.value, "YYYY-MM-DD")
                .format(target.getAttribute("data-date-format"))
        )
        targets.setAttribute(
            "data-date",
            moment(e.target.value, "YYYY-MM-DD")
                .format(targets.getAttribute("data-date-format"))
        )
        if (index === 'from') {
            document.getElementById("fromdate").classList.remove("opacity-60");
            document.getElementById("fromdate").classList.add("active");
        }
        else if (index === 'to') {
            document.getElementById("todate").classList.remove("opacity-60");
            document.getElementById("todate").classList.add("active");
        }
        if (enddate != '') {
            if (startdate > enddate) {
                this.setState({ Fromdate: enddate });
            }
        }
        if (startdate != null && startdate != '') {
            update['fromdate'] = startdate
            store.dispatch({ type: 'urlappend', Urlappend: update })
        }
        if (enddate != null && enddate != '') {
            enddate = moment(enddate, "YYYY-MM-DD").add(1, 'days').format('YYYY-MM-DD');
            update['todate'] = enddate
            store.dispatch({ type: 'urlappend', Urlappend: update })
        }
        this.setState({ update: update });

    }
    /**
* @description The function executed for change in the sort by filter
*/
    handleFilter() {
        this.setState({ filter: !this.state.filter });
        // this.props.passToParent(this.state.filter)
    }
    /**
* @description The function executed for paymentoption
*/
    handlePayment = paymentOption => {
        this.setState({ paymentOption });
        console.log(`Option selected:`, paymentOption);
        var update = this.state.update
        update['paymentmethod'] = paymentOption.value
        this.setState({ update: update });
        store.dispatch({ type: 'urlappend', Urlappend: update })
    };
    render() {
        return (
            <div className='filter-order'>
                <button className='filter-btn bg-white   py-1 w-32 px-4  shadow-shadowblack  flex' onClick={() => this.handleFilter()}>
                    <span className='font-OpenSans font-semibold text-left text-base text-bluecolor '>Filters</span>
                    <img src='/static/Icons/filter-icon.svg' alt='' className={'my-auto ml-auto transform  ' + (this.state.filter === true ? '' : ' rotate-180')} />
                </button>
                <img src='/static/Icons/filter.svg' alt='' className={'' + (this.state.filter === true ? 'block' : 'hidden')} />
                <div className={'bg-white bottom-3 relative shadow-shadowblack filter-main ' + (this.state.filter === true ? 'block' : 'hidden')}>
                    <div className='xl:px-10 px-5 py-7'>
                        <div className='flex '>
                            {/* The Payment field */}
                            <div className='xl:w-3/12 w-4/12'>
                                <div className='xl:w-9/12 w-10/12'>
                                    <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Payment No</span>
                                    <div className=' w-full'>
                                        <input type='text' className="w-full border-b border-bluecolor py-2 pr-3 text-bluecolor font-OpenSans text-sm       font-semibold" id='paymentno'
                                            placeholder="PaymentNo" onChange={this.handleForm} defaultValue={this.state.update.paymentno} maxLength={this.state.varchar['LG']}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* The Order field */}
                            <div className='xl:w-3/12 w-4/12'>
                                <div className='xl:w-9/12 w-10/12'>
                                    <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Order #</span>
                                    <div className=' w-full'>
                                        <input type='text' className="w-full border-b border-bluecolor py-2 pr-3 text-bluecolor font-OpenSans text-sm       font-semibold" id='orderno'
                                            placeholder="OrderNo" onChange={this.handleForm} defaultValue={this.state.update.orderno} maxLength={this.state.varchar['LG']}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* The Status field */}
                            <div className=' xl:w-3/12 w-4/12 '>
                                <div className='xl:w-9/12 w-10/12'>
                                    <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Status</span>
                                    <div className=' w-full status-select'>
                                        <Select
                                            value={this.state.selectedOption}
                                            onChange={this.handleChange}
                                            options={this.state.Status} isSearchable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* The desktop view of datetimepicker */}
                            <div className='xl:w-4/12 w-8/12 ml-auto xl:block hidden'>
                                <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Date</span>
                                <div className='  flex '>
                                    <div className='flex pt-3  w-1/2 '>
                                        <span className='font-OpenSans font-semibold  text-sm text-bluecolor mt-auto opacity-60 '>FROM </span>
                                        <input type="date" id="fromdate" name="fromdate" data-date="MM/DD/YYYY" max={this.state.currenDate} data-date-format={this.state.FORMAT} className={'active xl:ml-6 ml-3 Fromdate uppercase text-bluecolor font-OpenSans mt-auto font-semibold  border-b border-bluecolor w-max active ' + this.state.fromactive + (this.state.fromopacity === ' active ' ? '' : ' opacity-60 ')} defaultValue={this.state.update.fromdate} onChange={(e) => this.handleDate(e, "from")} />
                                    </div>
                                    <div className='flex pt-3 w-1/2'>
                                        <span className='font-OpenSans font-semibold text-sm text-bluecolor mt-auto opacity-60 ml-3 '>TO </span>
                                        <input type="date" id="todate" name="todate" data-date="MM/DD/YYYY" max={this.state.currenDate} data-date-format={this.state.FORMAT} className={'active xl:ml-6 ml-3 Todate  uppercase text-bluecolor font-OpenSans mt-auto font-semibold   border-b border-bluecolor w-max active ' + this.state.toactive + (this.state.toopactity === ' active ' ? '' : ' opacity-60 ')} defaultValue={this.state.update.todate} onChange={(e) => this.handleDate(e, "to")} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Tab view of the date picker and customer field */}
                        <div className='w-full py-2 pt-8 flex xl:hidden'>
                            <div className='w-9/12   xl:hidden block mr-1 '>
                                <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Date</span>
                                <div className='  flex '>
                                    <div className='flex pt-3  w-1/2 '>
                                        <span className='font-OpenSans  font-semibold text-sm text-bluecolor mt-auto opacity-80'>FROM </span>
                                        <input type="date" id="fromdate" name="fromdate" data-date="MM/DD/YYYY" max={this.state.currenDate} data-date-format={this.state.FORMAT} className={'active  Fromdate xl:ml-6 ml-3 uppercase text-bluecolor font-OpenSans mt-auto font-semibold  border-b border-bluecolor w-max  ' + this.state.fromactive + (this.state.fromopacity === ' active ' ? '' : ' opacity-60 ')} defaultValue={this.state.update.fromdate} onChange={(e) => this.handleDate(e, "from")} />
                                    </div>
                                    <div className='flex pt-3 w-1/2'>
                                        <span className='font-OpenSans  font-semibold Todate text-sm text-bluecolor mt-auto opacity-80 ml-3 '>TO </span>
                                        <input type="date" id="todate" name="todate" data-date="MM/DD/YYYY" max={this.state.currenDate} data-date-format={this.state.FORMAT} className={'active xl:ml-6 ml-3 uppercase text-bluecolor font-OpenSans mt-auto font-semibold opacity-80  border-b border-bluecolor w-max  ' + this.state.toactive + (this.state.toopactity === ' active ' ? '' : ' opacity-60 ')} defaultValue={this.state.update.todate} onChange={(e) => this.handleDate(e, "to")} />
                                    </div>
                                </div>
                            </div>
                            <div className='w-3/12 xl:hidden block'>
                                <div className=' w-11/12 '>
                                    <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Customer Name</span>
                                    <div className=' w-full'>
                                        <input type='text' id='name' name='name' className="w-full border-b border-bluecolor py-2 pr-3 text-bluecolor font-OpenSans text-sm       font-semibold"
                                            placeholder="Name" defaultValue={this.state.update.name} onChange={this.handleForm} maxLength={this.state.varchar['SM']}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-full py-7 xl:flex'>
                            <div className='xl:w-full w-full flex'>
                                {/* The tab view of the customer field */}
                                <div className='w-4/12 xl:block hidden'>
                                    <div className='xl:w-9/12 w-10/12'>
                                        <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Customer Name</span>
                                        <div className=' w-full'>
                                            <input type='text' id='name' name='name' className="w-full border-b border-bluecolor py-2 pr-3 text-bluecolor font-OpenSans text-sm       font-semibold"
                                                placeholder="Name" defaultValue={this.state.update.name} onChange={this.handleForm} maxLength={this.state.varchar['SM']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* The cutomer email field */}
                                <div className='w-4/12'>
                                    <div className='xl:w-9/12 w-10/12'>
                                        <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Customer Email</span>
                                        <div className=' w-full'>
                                            <input type='email' id='email' className="w-full border-b border-bluecolor py-2 pr-3 text-bluecolor font-OpenSans text-sm    font-semibold" pattern="/\S+@\S+\.\S+/"
                                                placeholder="Email" defaultValue={this.state.update.email} onChange={this.handleForm} maxLength={this.state.varchar['MD']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* The Payment Method field */}
                                {/* <div className='w-3/12'>
                                    <div className='xl:w-9/12 w-10/12'>
                                        <span className='order-name-text font-OpenSans font-semibold text-sm text-redcolor'>Payment Method</span>
                                        <div className=' w-full status-select'>
                                            <Select
                                                value={this.state.paymentOption}
                                                onChange={this.handlePayment}
                                                options={this.state.paymentmethod} isSearchable={false}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                <div className=' xl:w-2/7 w-4/12 mt-5  ml-auto '>
                                    <div className='ml-auto xl:ml-auto my-auto w-max'>
                                        <button className='text-white bg-redcolor flex mx-auto px-6 py-1 rounded-lg ' onClick={() => this.handleSubmit()}><span className='text-base font-OpenSans font-normal'>Apply Filter</span><span className='text-white my-auto ml-3'><CgSearch /></span></button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div >
        )
    }
};

export default Filter;